import { Observable, Subscription } from "rxjs";

import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { Call } from "app/models/call";
import { CallService } from "../../../services/call.service";
import { Response } from "@angular/http";
import { PagedListAdapter } from "../../../common/paged-list-adapter";
import { PagedResult } from "../../../models/PagedResult";
import { Work } from "app/models/work";
import { Location } from "app/models/location";

import swal from "bootstrap-sweetalert";
import * as _ from 'lodash';
import { saveAs } from "file-saver";


import { WorkTask } from "app/models/workTask";
import { AssetService } from "app/services/asset.service";
import { ServiceObjectBase } from "app/models/serviceObject";
import { ProfileService } from "app/services/profile.service";
import { FileStorageService } from "app/services/fileStorage.service";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { Lightbox } from "angular2-lightbox";
import { PhotoType } from "app/models/photoDataPhotoType";
import { Obstruction } from "../../../models/obstruction";
import { AuthenticationService } from "app/services/authentication.service";
import { User } from "app/models/user";
import { Survey } from "app/models/surveyScheme/survey";

@Component({
  templateUrl: './call-details.component.html',
  styleUrls: ['./call-details.component.scss']
})
export class CallDetailsComponent implements OnInit, OnDestroy {

  private _call: Call;
  private _callsAdapter: PagedListAdapter<Call>;
  private _errorState: CallDetailsComponent.ErrorState = CallDetailsComponent.ErrorState.None;
  private _callStatuses = Call.Status;
  private _cancelStatuses = Call.CancelStatus;
  private _photos: Array<any> = [];
  private _callTasksWithSurvey: Array<WorkTask> = [];
  private _newCallMessage: string = "";
  private _selectedTab: string = "info";
  private callConfirmationPermission: boolean;
  private canAccessPhotos: boolean;
  private canAccessReports: boolean;
  private canAccessSurveys: boolean;
  private _isShowConfirmationButton: boolean;
  private _isShowMessageInputField: boolean;

  constructor(
    private _route: ActivatedRoute,
    private _callService: CallService,
    private _assetService: AssetService,
    private _profileService: ProfileService,
    private _domSanitizer: DomSanitizer,
    private _lightbox: Lightbox,
    private _authenticationService: AuthenticationService,
    private _fileStorage: FileStorageService,
    private router: Router,
    public sanitizer: DomSanitizer) {
    this.callConfirmationPermission = this._profileService.checkHasCallConfirmationPermission();
    this._isShowConfirmationButton = !!(_authenticationService.authenticatedUser.permissions & User.Permissions.Write);
    this._isShowMessageInputField = !!(_authenticationService.authenticatedUser.permissions & User.Permissions.Write);
    this.canAccessPhotos = this._profileService.checkHasAccessPhotoPermission();
    this.canAccessReports = this._profileService.checkHasAccessReportsPermission();
    this.canAccessSurveys = this._profileService.checkHasAccessSurveysPermission();
  }

  ngOnInit(): void {
    this._selectedTab = (this._route.snapshot.params['tab']) ? this._route.snapshot.params['tab'] : "info";
    this.loadData();
  }

  ngOnDestroy(): void {
    this.clearSubscription();
    swal.close();
  }

  private confirmCall(call: Call) {
    if (!this.callConfirmationPermission)
      return;

    this._callService.confirmCall(call)
      .subscribe(_ => {
        call.isConfirmed = true;
        swal("Ок!", "Обращение успешно подтверждено.", "success");

      }, err => {
        swal("Упс..", "Кажется, что-то пошло не так, попробуйте обновить страницу.", "error");
      });
  }

  private cancelCall(call: Call) {
    this._callService.cancelCall(call)
      .subscribe(_ => {
        call.cancelStatus = Call.CancelStatus.Requested;
        swal("Ок", "Запрос на отмену обращения отправлен", "success");
      }, err => {
        switch (err._body.ErrorCode) {
          case 5:
            swal("Ошибка", "Доступ к обращению запрещен", "error")
            break;
          case 10:
            swal("Ошибка", "Для отмены доступны только обращения созданные через Личный кабинет", "error");
            break;
          case 11:
            swal("Ошибка", "Нет прав доступа для отмены", "error")
            break;
          case 12:
            swal("Ошибка", `Обращение в статусе "Закрыто"`);
            break;
          default:
            swal("Упс..", "Кажется, что-то пошло не так, попробуйте обновить страницу.", "error");
            break;
        }
      })

  }

  private sendComment(): Observable<any> {
    return Observable.create(observer => {
      this._callService.sendCallMessage(this._call, this._newCallMessage).subscribe(callMessage => {
        this._call.messages.push(callMessage);
        this._call.messages = _.orderBy(this._call.messages, ['date'], ['desc']);
        this._newCallMessage = "";
        observer.complete();
        swal('Ок', 'Ваше сообщение успешно отправлено', 'success');
      }, err => {
        swal('Ошибка сообщения', 'При отправке сообщения произошла ошибка', 'error');
      });
    });
  }

  private loadData(): void {
    this._errorState = CallDetailsComponent.ErrorState.None;

    let callId: number = +this._route.snapshot.params['id'];
    this.clearSubscription();

    this._callService.getCallDetails(callId)
      .subscribe(call => {
        this._call = call;

        var self = this;
        if (call != null && call.works != null) {
          this._callTasksWithSurvey = _.flatMap(call.works, x => x.tasks).filter(x => x.survey != null);
          _.each(call.works, function (work) {
            if (self._call.status == Call.Status.Closed) {
              work.address = (work.fixedAddress != null) ? work.fixedAddress : "";
            }
            else if (work.serviceObject instanceof Location) {
              work.address = (work.serviceObject.address != null) ? work.serviceObject.address : "-";
            }
            else {
              self._assetService.getAssetPath(work.serviceObject.id)
                .subscribe(serviceObjects => {
                  if (serviceObjects.length > 0) {
                    var location = serviceObjects[0] as Location;
                    work.address = (location.address != null) ? location.address : "";
                  } else {
                    console.error("Server error! Could not get work address");
                  }
                }, err => {
                  swal({
                    title: 'Ошибка',
                    text: 'Не удалось получить адрес объекта обслуживания. Попробуйте снова',
                    type: 'error',
                    confirmButtonText: 'Попробовать еще раз'
                  }, () => {
                    self.loadData();
                  });
                });
            }
          });
        }
      }, error => {
        if (error instanceof Response && (error.status == 403 || error.status == 404)) {
          this.router.navigateByUrl('/pagenotfound');
        } else {
          this._errorState = CallDetailsComponent.ErrorState.UnknownError;
          swal({
            title: 'Ошибка',
            text: 'Не удалось получить данные обращения. Попробуйте снова',
            type: 'error',
            confirmButtonText: 'Попробовать еще раз'
          }, () => {
            this.loadData();
          });
        }
      });
  }

  setActiveTab(selectedTab: string): void {
    this._selectedTab = selectedTab;
    window.history.replaceState({}, '', `/call/${this._call.id}/${this._selectedTab}`);
  }

  private isHasActiveObstruction(obstructions: Obstruction[]): boolean {
    if (obstructions == null)
      return false;

    var test = _.some(obstructions, function (obstruction) {
      return (obstruction.finishDate == null ? true : false);
    });

    return test;
  }

  //Открытие фотографии в lightbox'e
  private openPhoto(fileId: string): void {

    let index = _.findIndex(this._photos, { fileId: fileId });

    this._lightbox.open(this._photos, index);
  }

  //Получение Blob'а фотографии для отображения
  private getPhoto(fileId: string, type: PhotoType): Observable<any> {

    let url = this._fileUrls[fileId];

    if (url == null) {
      url = this._fileStorage.getPhotoFile(fileId, type)
        .map(e => {
          let resourseUrl = this._domSanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(e))

          this._photos.push({
            src: resourseUrl,
            caption: null,
            thumb: null,
            fileId: fileId
          });

          return resourseUrl;
        })

      this._fileUrls[fileId] = url;
    }

    return url;
  }

  private downloadPhoto(fileId: string, type: PhotoType, photoNumber: number): Observable<Blob> {
    if (fileId == null || type == null)
      return null;

    this._fileStorage
      .getPhotoFile(fileId, type)
      .subscribe(result => saveAs(result, `Обр_${this._call.number}_${photoNumber}`))

  }

  private downloadArchive(): Observable<Blob> {
    if (this._call == null)
      return null;

    this._fileStorage
      .getCallPhotoAchive(this._call.id)
      .subscribe(result => saveAs(result, "Обр_" + this._call.number));
  }

  private _fileUrls: { [fileId: string]: Observable<SafeUrl> } = {};

  private clearSubscription() {
    if (this.assetPathLoadSubscription)
      this.assetPathLoadSubscription.unsubscribe();

    this.assetPathLoadSubscription = null;
    this._call = null;
  }

  private convertCallStatusToText(status: Call.Status): string {
    switch (status) {
      case Call.Status.Opened: return "Открыто";
      case Call.Status.Closed: return "Закрыто";
      default: return "";
    }
  }

  private convertCancelStatusToText(status: Call.CancelStatus): string {
    switch (status) {
      case Call.CancelStatus.Requested: return "Отправлен запрос на отмену"
      case Call.CancelStatus.Successful: return "Обращение отменено"
      case Call.CancelStatus.Unsuccessful: return "Отмена обращения невозможна"
      default: return '';
    }
  }

  private convertCallTaskStatusToText(status: WorkTask.Status): string {
    switch (status) {
      case WorkTask.Status.New: return "Новая";
      case WorkTask.Status.Assigned: return "Назначена";
      case WorkTask.Status.Done: return "Выполнена";
      case WorkTask.Status.Canceled: return "Отменена";
      default: return "";
    }
  }

  private assetPathLoadSubscription: Subscription;
  private ErrorStateEnum = CallDetailsComponent.ErrorState;

}

export namespace CallDetailsComponent {
  export enum ErrorState {
    /**
     * Нет ошибок
     */
    None,
    /**
     * Сервер не может предоставить данные по объекту обслуживания (его не существует или доступ к данным запрещен)
     */
    NoData,
    /**
     * Другая ошибка
     */
    UnknownError
  }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/client/call/details/call-details.component.ts